export const REMINDER_CATEGORY = {
  OVERDUE: 'Overdue',
  EXPIRED: 'Expired',
  RESOLVED: 'Resolved',
  OPEN: 'Open',
  DECLINED: 'Declined',
}
